import React from "react";
import FilterBadge from "../../../revampComponents/Atom/Badge/FilterBadge";
import _ from "lodash";

const SelectedFiltersDisplay = ({ selectedFilters, setSelectedFilters, displaySelectedFilters, getFilterName,statusDataName,priorityDataName , setIsRemoveFilterClicked , isRemoveFilterClicked,setSelectedStatus , ticketOptions = [],}) => {
    if (!displaySelectedFilters || _.isEmpty(selectedFilters)) return null;

    const getFilterStatusName = (selectedFilter) => {
        if (!statusDataName || !Array.isArray(statusDataName) || statusDataName.length === 0) {
            return selectedFilter; 
        }
        const filterOption = statusDataName[0].options.find(option => String(option.value) === String(selectedFilter));
    
        if (!filterOption) {
            return selectedFilter; 
        }
        return filterOption.label; 
    };
    const  getPriorityLabel =(priorityData, id)  =>{
        const option = priorityData.options.find(opt => opt.value === id);
        return option ? option.label : "Unknown"; 
    }
    const getTicketName = (ticketId) => {
        const option = ticketOptions?.find(opt => String(opt?.value) === String(ticketId))
        return option ? option?.label : ticketId
    }

    return (
        <div className="mb-2 mt-4">
            {Object.keys(selectedFilters).map((filterId) =>
                selectedFilters[filterId].map((selectedFilter, index) => (
                    <FilterBadge
                        key={index}
                        onClick={() => {
                            setSelectedFilters(prev => ({
                                ...prev,
                                [filterId]: prev[filterId].filter(filter => filter !== selectedFilter)
                            }));
                            setIsRemoveFilterClicked(true);
                            setSelectedStatus('');
                        }}
                    >
                        {filterId === "status"
                            ? getFilterStatusName(selectedFilter)
                            : filterId === "exhibitors"
                                ? getFilterName(selectedFilter)
                                : filterId === "priority"
                                    ? getPriorityLabel(priorityDataName, selectedFilter)
                                    : filterId ===  "ticket_id"
                                        ?  getTicketName(selectedFilter)
                                        : selectedFilter}
                    </FilterBadge>
                ))
            )}
        </div>
    );
};

export default SelectedFiltersDisplay;
